/**
 * Anchos estándar de paneles y modales.
 *
 * Cada pantalla venía eligiendo el suyo -`sm:max-w-xl` en un detalle,
 * `sm:max-w-[680px]` en otro, `sm:max-w-[880px]` en el de junto-, así que dos
 * paneles del mismo flujo abrían con anchos distintos y el contenido saltaba
 * de sitio al cambiar de uno a otro. Estas constantes son el único ancho que
 * se usa; si un panel necesita otro, se agrega aquí con su razón.
 */

/**
 * Panel lateral de detalle (Sheet): ficha de un caso, un cliente, una
 * propiedad. Cabe una rejilla de dos columnas y una tabla compacta sin
 * apretarse, y deja ver la pantalla de atrás.
 */
export const PANEL_DETALLE = "w-full sm:max-w-3xl";

/**
 * Panel de desglose de gráfica (`DesgloseGrafica`): tabla de 6 a 8 columnas con nombres y montos
 * que no deben apretarse; en 390 px ocupa la pantalla igual que `PANEL_DETALLE`.
 */
export const PANEL_DESGLOSE = "w-full sm:max-w-5xl";

/**
 * Modal de una sola columna: formulario corto, confirmación con motivo,
 * lista breve.
 */
export const MODAL_FORM = "sm:max-w-lg";

/**
 * Modal de tabla: varias columnas numéricas que no deben romperse en dos
 * renglones.
 */
export const MODAL_TABLA = "sm:max-w-4xl";

/**
 * Vista previa de un correo: el HTML de los templates se maqueta a 600px, así
 * que `MODAL_FORM` lo corta y `MODAL_TABLA` deja aire vacío a los lados.
 */
export const MODAL_VISTA_PREVIA = "sm:max-w-2xl";

/**
 * Visor partido (documento + detalle escrito). Más ancho a propósito: son dos
 * columnas y el PDF necesita alto y ancho para leerse sin descargarlo.
 */
export const MODAL_VISOR = "sm:max-w-5xl";

/**
 * Modales de un mismo flujo que se abren uno tras otro (subir uno, subir varios, editar, agregar
 * cuenta en Estados de cuenta): mismo ancho y mismo alto mínimo del cuerpo, para que al pasar de
 * uno a otro la ventana no cambie de tamaño. Cabe una fila de lote (archivo, año, mes, estado,
 * quitar) sin partirse.
 */
export const MODAL_FLUJO = "sm:max-w-2xl";
export const MODAL_FLUJO_CUERPO = "min-h-[360px]";

/**
 * Modal con menú de secciones a la izquierda (`ui/modal-secciones`, Mi cuenta): ancho y alto fijos
 * para que la ventana no cambie de tamaño al pasar de una sección a otra. En móvil es hoja inferior
 * de 90vh.
 */
export const MODAL_SECCIONES = "sm:max-w-4xl";
export const MODAL_SECCIONES_ALTO = "h-[90vh] max-sm:overflow-hidden sm:h-[min(640px,88vh)]";
